// import Swiper from "swiper/bundle";
// import Swiper from 'swiper/bundle';
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
Swiper.use([Navigation, Pagination]);
// import Swiper, { EffectFade } from "swiper/bundle";
// Swiper.use([EffectFade]);

export default class {
	constructor(options) {
		const scopeThis = this;
		this.defaults = {
			$el: null,
			minItems: 2,
			galPrimary: null,
			galThumbs: null,
			swiperArgs: {
				slidesPerView: 1,
				grabCursor: true,
				loop: false,
				autoadvance: false,
				pagination: {
					el: ".swiper-pagination",
				},
				mousewheel: {
					forceToAxis: true,
					releaseOnEdges: true,
				},
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},
				autoopts: {
					currcycle: 0,
					maxcycle: 1000,
				},
				on: {
					init: function (swiper) {
						swiper.el.addEventListener("keydown", function (e) {
							if (e.key === "Tab") {
								var focusEl =
									document.activeElement.closest(
										".swiper-slide"
									);
								if (
									null != focusEl &&
									!focusEl.classList.contains(
										"swiper-slide-active"
									)
								) {
									var slideIndex =
										Array.prototype.indexOf.call(
											focusEl.parentNode.children,
											focusEl
										);
									this.swiper.slideTo(slideIndex);
								}
							}
						});
					},
				},
			},
		};
		this.options = {};

		this.swiperThumb = null;
		this.swiperMain = null;

		Object.assign(this.options, this.defaults, options);

		this.namespace = "SwiperThumbs";
		if (this.options.$el) {
			this.$el = this.options.$el;
			this.init(true);
		}
	}

	init(bool) {
		const scopeThis = this;
		if (bool) {
			let args = this.options.swiperArgs;
			let elScope = this.$el;

			args.navigation = {
				nextEl: this.$el.parentElement.querySelector(".next"),
				prevEl: this.$el.parentElement.querySelector(".prev"),
			};

			if (this.$el.classList.contains("auto-advance")) {
				args.autoadvance = true;
			}

			this.galPrimary = this.$el.querySelector(".gal-primary");
			this.galThumbs = this.$el.querySelector(".gal-thumb");
			// set this.galUse to the data-gallery attribute of this.$el
			this.galUse = this.$el.getAttribute("data-gallery");

			// this.swiper = new Swiper(this.$el, args);

			this.swiperThumb = new Swiper(
				'[data-gallery="' + this.galUse + '"] .gal-thumb',
				{
					spaceBetween: 10,
					slidesPerView: "auto",
					// slidesPerView: "auto",
					freeMode: true,
					watchSlidesProgress: true,
					watchSlidesVisibility: false,
					watchOverflow: true,
				}
			);

			// when swiperThumb is ready, set swiperMain
			scopeThis.swiperThumb.slides[0].classList.add("active");
			// this.swiperThumb.on("init", function () {
			// });
			// scopeThis.setSwiperMain();
			// console.log(this.swiperThumb);

			this.swiperMain = new Swiper(
				'[data-gallery="' + this.galUse + '"] .gal-primary',
				{
					spaceBetween: 0,
					slidesPerView: 1,
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev",
					},
					thumbs: {
						swiper: scopeThis.swiperThumb,
					},
				}
			);

			this.swiperThumb.on("click", function () {
				scopeThis.swiperMain.slideTo(this.clickedIndex);
				scopeThis.swiperThumb.slideTo(this.clickedIndex);
			});

			this.swiperMain.on("slideChange", function () {
				scopeThis.swiperThumb.slides.forEach(function (el) {
					el.classList.remove("active");
				});

				scopeThis.swiperThumb.slides[
					scopeThis.swiperMain.activeIndex
				].classList.add("active");
			});
			// });
		} else {
			this.swiper.destroy(true, true);
		}
	}

	timerTick() {}
}
